import api from "../../config/client.axios.api";

export const getVoucherApi = async (page: any, size: any) => {
  const response = await api.get(
    `/voucher/find-vouchers?page=${page}&size=${size}`
  );
  return response.data;
};
